/**
 * Leaves the Performance module for the Engagement Recognition feed, in the same tab.
 *
 * A full navigation rather than the module's router: the feed is a route of the host application,
 * which the module is only one page of, so `useNavigate` would look for it among the module's own
 * routes and find nothing. The same tab because the feed is where the reader carries on — reading
 * the whole message, liking it, recognizing someone back — and a second tab would load another copy
 * of the host and take the Back button away from them.
 */
export const openRecognitionFeed = (feedPath: string) => {
    window.location.assign(feedPath);
};
